"use client";

import { Checkbox as HeroCheckbox } from "@heroui/react";
import { cn } from "../../lib/utils";
import styles from "./Checkbox.module.css";

export const Checkbox = ({
  className,
  classNames,
  ...props
}: { className?: string; classNames?: React.ComponentProps<typeof HeroCheckbox>["classNames"] } & React.ComponentProps<
  typeof HeroCheckbox
>) => {
  const { color } = props;
  return (
    <HeroCheckbox
      data-color={color}
      className={cn(styles.checkbox, className)}
      classNames={{
        ...classNames,
        label: cn("text-base", classNames?.label),
      }}
      {...props}
    />
  );
};
